import { render, staticRenderFns } from "./ActionPlanActivityCard.vue?vue&type=template&id=0b65d320&"
import script from "./ActionPlanActivityCard.vue?vue&type=script&lang=ts&"
export * from "./ActionPlanActivityCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports